import { render } from "./UserLikedItemListPage.vue?vue&type=template&id=3bf9674a&ts=true"
import script from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"
export * from "./UserLikedItemListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__